// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Caml_format from "../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as MsisdnValidation from "../../../../../library/work-space/form/MsisdnValidation.bs.js";
import * as Formality__ReactUpdate from "../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as FormValidationUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/FormValidationUtils.bs.js";

var validators_penalty_type = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var penalty_type = param.penalty_type;
      if (penalty_type !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: Caml_format.caml_int_of_string(penalty_type.value)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Select penalty type"
              };
      }
    })
};

var validators_msisdn = {
  strategy: /* OnFirstChange */1,
  validate: (function (param, metadata) {
      var msisdn = param.msisdn;
      if (msisdn.length !== 0) {
        return MsisdnValidation.execute(msisdn, metadata.country);
      } else {
        return {
                TAG: /* Error */1,
                _0: "Enter partner msisdn"
              };
      }
    })
};

var validators_crn = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      return FormValidationUtils$Catalyst.validateCRN(param.crn);
    })
};

var validators = {
  penalty_type: validators_penalty_type,
  msisdn: validators_msisdn,
  crn: validators_crn
};

function initialFieldsStatuses(_input) {
  return {
          penalty_type: /* Pristine */0,
          msisdn: /* Pristine */0,
          crn: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            penalty_type: /* Pristine */0,
            msisdn: /* Pristine */0,
            crn: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.penalty_type;
  var match_0 = match ? match._0 : Curry._2(validators.penalty_type.validate, input, metadata);
  var match$1 = fieldsStatuses.msisdn;
  var match_0$1 = match$1 ? match$1._0 : Curry._2(validators.msisdn.validate, input, metadata);
  var match$2 = fieldsStatuses.crn;
  var match_0$2 = match$2 ? match$2._0 : Curry._2(validators.crn.validate, input, metadata);
  var penalty_typeResult = match_0;
  var penalty_typeResult$1;
  if (penalty_typeResult.TAG === /* Ok */0) {
    var msisdnResult = match_0$1;
    if (msisdnResult.TAG === /* Ok */0) {
      var crnResult = match_0$2;
      if (crnResult.TAG === /* Ok */0) {
        return {
                TAG: /* Valid */0,
                output: {
                  crn: crnResult._0,
                  msisdn: msisdnResult._0,
                  penalty_type: penalty_typeResult._0
                },
                fieldsStatuses: {
                  penalty_type: /* Dirty */{
                    _0: penalty_typeResult,
                    _1: /* Shown */0
                  },
                  msisdn: /* Dirty */{
                    _0: msisdnResult,
                    _1: /* Shown */0
                  },
                  crn: /* Dirty */{
                    _0: crnResult,
                    _1: /* Shown */0
                  }
                },
                collectionsStatuses: undefined
              };
      }
      penalty_typeResult$1 = penalty_typeResult;
    } else {
      penalty_typeResult$1 = penalty_typeResult;
    }
  } else {
    penalty_typeResult$1 = penalty_typeResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            penalty_type: /* Dirty */{
              _0: penalty_typeResult$1,
              _1: /* Shown */0
            },
            msisdn: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            crn: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurPenalty_typeField */0 :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.penalty_type, validators_penalty_type, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  penalty_type: status,
                                  msisdn: init.msisdn,
                                  crn: init.crn
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurMsisdnField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.msisdn, validators_msisdn, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  penalty_type: init.penalty_type,
                                  msisdn: status,
                                  crn: init.crn
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCrnField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.crn, validators_crn, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  penalty_type: init.penalty_type,
                                  msisdn: init.msisdn,
                                  crn: status
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */3 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */3,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */4,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */6);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */5);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */4 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */5 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */6 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdatePenalty_typeField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.penalty_type, state.submissionStatus, validators_penalty_type, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            penalty_type: status,
                                            msisdn: init.msisdn,
                                            crn: init.crn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateMsisdnField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.msisdn, state.submissionStatus, validators_msisdn, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            penalty_type: init.penalty_type,
                                            msisdn: status,
                                            crn: init.crn
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCrnField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$2, metadata, state.fieldsStatuses.crn, state.submissionStatus, validators_crn, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            penalty_type: init.penalty_type,
                                            msisdn: init.msisdn,
                                            crn: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */3 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                penalty_type: /* Pristine */0,
                                msisdn: /* Pristine */0,
                                crn: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                penalty_type: /* Pristine */0,
                                msisdn: /* Pristine */0,
                                crn: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */4 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */5 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updatePenalty_type: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdatePenalty_typeField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateMsisdn: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateMsisdnField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCrn: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCrnField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurPenalty_type: (function (param) {
              return Curry._1(dispatch, /* BlurPenalty_typeField */0);
            }),
          blurMsisdn: (function (param) {
              return Curry._1(dispatch, /* BlurMsisdnField */1);
            }),
          blurCrn: (function (param) {
              return Curry._1(dispatch, /* BlurCrnField */2);
            }),
          penalty_typeResult: Formality.exposeFieldResult(state.fieldsStatuses.penalty_type),
          msisdnResult: Formality.exposeFieldResult(state.fieldsStatuses.msisdn),
          crnResult: Formality.exposeFieldResult(state.fieldsStatuses.crn),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.penalty_type || match.msisdn || match.crn) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */3);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */4);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */5);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */5,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */6);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

export {
  Form ,
  
}
/* react Not a pure module */
